<template>
  <v-autocomplete
    :menu-props="{ bottom: true, offsetY: true }"
    class="rounded-lg"
    :items="items"
    v-model="item"
    :label="label"
    item-text="name"
    item-value="id"
    :disabled="disabled"
    :multiple="multiple"
    :return-object="false"
  ></v-autocomplete>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";
export default {
  name: "WarehouseSelect",
  mixins: [wareApiMixin],
  props: {
    value: {},
    label: {
      default: null,
    },
    disabled: {
      default: false,
    },
    multiple: {
      default: false,
    },
  },
  data() {
    return {
      item: null,
    };
  },
  computed: {
    items() {
      let items = [];
      if (this.multiple == "") {
        items = [
          {
            name: "همه انبار ها",
            id: 0,
          },
          {
            divider: true,
          },
          ...this.warehouses,
        ];
      } else {
        items = this.warehouses;
      }
      return items;
    },
  },
  created() {
    this.getWarehouses();
  },
  mounted() {
    this.setItem();
  },
  methods: {
    setItem() {
      if (this.value != this.item) this.item = this.value;
    },
  },
  watch: {
    value() {
      this.setItem();
    },
    item() {
      if (this.value && this.value.includes(0) && this.item.length > 1) {
        this.item.splice(this.item.indexOf(0), 1);
      }

      if (this.value && this.item.includes(0) && !this.value.includes(0)) {
        this.item = [0];
      }

      this.$emit("input", this.item);
    },
  },
};
</script>

<style lang="scss" scoped></style>
